/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { bem } from "../../../shared/BEM";
import { renderFormElementList } from "./renderFormElement";
import { FormSection } from "../../../shared/FormModel/elements/FormSection";
import { useFormElement } from "../../../shared/hooks/useFormElement";

/**
 * Component props
 */
export interface IFormSectionComponentProps {
	element: FormSection
}

export function FormSectionComponent(props: IFormSectionComponentProps) {

	const state = useFormElement(props.element);

	const stlMods = [];

	switch(state.config.width) {
		case "1/2":
			stlMods.push("width-1-2"); break;
		case "1/3":
			stlMods.push("width-1-3"); break;
		case "2/3":
			stlMods.push("width-2-3"); break;
		default:
			stlMods.push("width-1"); break;
	}

	const stl = bem("form-section", "", stlMods);

	return <section className={stl.str}>
		{ state.config.title ?
		<header className={stl.el("header").str}>
			<h3 className={stl.el("header-title").str}>{state.config.title}</h3>
		</header>
		: null }
		<div className={stl.el("content").str}>
			{renderFormElementList(state.content)}
		</div>
	</section>;

}